"use client";
var __defProp = Object.defineProperty;
var __name = (target, value) => __defProp(target, "name", { value, configurable: true });

// src/components/organisms/toast/use-toast.ts
import { nanoid } from "@base/utils/crypto";
import { G } from "@mobily/ts-belt";
import { useEffect, useState } from "react";
import { match } from "ts-pattern";
var TOAST_LIMIT = 1;
var TOAST_REMOVE_DELAY = 1e6;
var toastTimeouts = /* @__PURE__ */ new Map();
var addToRemoveQueue = /* @__PURE__ */ __name((toastId) => {
  if (toastTimeouts.has(toastId)) {
    return;
  }
  const timeout = setTimeout(() => {
    toastTimeouts.delete(toastId);
    dispatch({
      type: "REMOVE_TOAST",
      toastId
    });
  }, TOAST_REMOVE_DELAY);
  toastTimeouts.set(toastId, timeout);
}, "addToRemoveQueue");
var reducer = /* @__PURE__ */ __name((state, action) => match(action).with({ type: "\
ADD_TOAST" }, ({ toast: toastData }) => ({
  ...state,
  toasts: [toastData, ...state.toasts].slice(0, TOAST_LIMIT)
})).with({ type: "UPDATE_TOAST" }, ({ toast: toastUpdate }) => ({
  ...state,
  toasts: state.toasts.map(
    (toastItem) => toastItem.id === toastUpdate.id ? { ...toastItem, ...toastUpdate } :
    toastItem
  )
})).with({ type: "DISMISS_TOAST" }, ({ toastId }) => {
  if (G.isNotNullable(toastId)) {
    addToRemoveQueue(toastId);
  } else {
    state.toasts.forEach((toastItem) => {
      addToRemoveQueue(toastItem.id);
    });
  }
  return {
    ...state,
    toasts: state.toasts.map(
      (toastItem) => toastItem.id === toastId || toastId === void 0 ? {
        ...toastItem,
        open: false
      } : toastItem
    )
  };
}).with({ type: "REMOVE_TOAST" }, ({ toastId }) => {
  if (toastId === void 0) {
    return {
      ...state,
      toasts: []
    };
  }
  return {
    ...state,
    toasts: state.toasts.filter((toastItem) => toastItem.id !== toastId)
  };
}).exhaustive(), "reducer");
var listeners = [];
var memoryState = { toasts: [] };
function dispatch(action) {
  memoryState = reducer(memoryState, action);
  listeners.forEach((listener) => {
    listener(memoryState);
  });
}
__name(dispatch, "dispatch");
function toast({ ...toastProps }) {
  const id = nanoid();
  const update = /* @__PURE__ */ __name((updatedProps) => dispatch({
    type: "UPDATE_TOAST",
    toast: { ...updatedProps, id }
  }), "update");
  const dismiss = /* @__PURE__ */ __name(() => dispatch({ type: "DISMISS_TOAST",
  toastId: id }), "dismiss");
  dispatch({
    type: "ADD_TOAST",
    toast: {
      ...toastProps,
      id,
      open: true,
      onOpenChange: /* @__PURE__ */ __name((open) => {
        if (!open) {
          dismiss();
        }
      }, "onOpenChange")
    }
  });
  return {
    id,
    dismiss,
    update
  };
}
__name(toast, "toast");
function useToast() {
  const [state, setState] = useState(memoryState);
  useEffect(() => {
    listeners.push(setState);
    return () => {
      const index = listeners.indexOf(setState);
      if (index > -1) {
        listeners.splice(index, 1);
      }
    };
  }, []);
  return {
    ...state,
    toast,
    dismiss: /* @__PURE__ */ __name((toastId) => dispatch({ type: "DISMISS_TOAST",
    toastId }), "dismiss")
  };
}
__name(useToast, "useToast");
export {
  reducer,
  toast,
  useToast
};
